<template>
	<section class="team">
		<div class="member" v-for="( member, index ) in members" :key="`member-${ index }`" :class="`member-${ member.align }`">
			<div class="member-scroller scroller" :data-dir="member.align">{{ member.name }}</div>
			<div class="member-container">
				<div class="member-image" data-anim="fade">
					<img :src="member.pic" alt="">
				</div>
				<div class="member-data">
					<h2 class="member-title" data-anim="flip">{{ member.name }}</h2>
					<div v-if="member.instagram" class="member-info">
						{{ member.info }}
						Folge ihm auf <a target="_blank" rel="noopener" :href="member.instagram">Instagram</a>.
					</div>
					<div v-else class="member-info">
						{{ member.info }}
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	export default {
		name: 'Team',
		// props: {
		// 	scroller: String
		// },
		data() {
			return {
				members: [
					{
						name: 'Phil',
						align: 'right',
						pic: '/img/philipp.png',
						info: 'Als sehr vielseitiger Künstler mit Wurzeln im Graffiti und Street-Art Bereich, konzentriere ich mich seit 2018 ausschließlich aufs Tätowieren.',
						instagram: null
					},
					// {
					// 	name: 'Jutta',
					// 	align: 'left',
					// 	pic: '/img/jutta.png',
					// 	info: 'Jutta pierct seit 2001 und kümmert sich außerdem um Wohlbefinden und Beratung unserer Kunden.',
					// 	instagram: null
					// },				
					// {
					// 	name: 'Phil',
					// 	align: 'right',
					// 	pic: '/img/phil.png',
					// 	info: 'Phil tätowiert seit 2015 und bemüht sich stets, gerade Linien zu ziehen.',
					// 	instagram: 'https://www.instagram.com/triestink/'
					// }
				]
			}
		}
	}
</script>